import {
	type Gabarit,
	getNatureFromGabarit,
	TYPE_GABARIT,
} from '@mairistem/finances-utils';
import ArticleNonBudgetairePanel from '../panel/ArticleNonBudgetairePanel';
import BaseProfilEcritureMouvement from './Base/BaseProfilEcritureMouvement';

class BaseProfilEcritureOPO extends BaseProfilEcritureMouvement {
	constructor() {
		super();
		this.isLiaisonVisible = false;
		this.panels = [...this.panels, new ArticleNonBudgetairePanel(true)];
	}

	getNaturesGabarit(gabaritsPj: Gabarit[]) {
		return getNatureFromGabarit(
			gabaritsPj?.find((g) => g.type === TYPE_GABARIT.OPO),
		);
	}
}

export default BaseProfilEcritureOPO;
